(function () {
  const D = window.Disco || {};
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* money */
  function money(cents) {
    const fmt = D.moneyFormat || '${{amount}}';
    const n = cents / 100;
    const two = n.toFixed(2);
    const noDec = Number.isInteger(n) ? String(n) : two;
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, noDec)
      .replace(/<[^>]+>/g, '');
  }
  function toast(t) {
    const e = $('#Toast'); if (!e) return;
    e.textContent = t; e.classList.add('on');
    clearTimeout(e._t); e._t = setTimeout(() => e.classList.remove('on'), 1800);
  }

  /* The age gate is handled entirely by the inline script in
     sections/age-gate.liquid, so it works the instant it paints rather than
     waiting for this deferred file. Nothing to do here. */

  /* gallery */
  $$('[data-gallery]').forEach(g => {
    const main = $('[data-gallery-main]', g);
    $$('[data-gallery-thumb]', g).forEach(b => b.addEventListener('click', () => {
      $$('[data-gallery-thumb]', g).forEach(x => x.setAttribute('aria-pressed', 'false'));
      b.setAttribute('aria-pressed', 'true');
      main.src = b.dataset.src; main.srcset = '';
    }));
  });

  /* product form / pack picker */
  $$('[data-product-form]').forEach(form => {
    const btn = $('[data-add]', form);
    const priceOut = $$('[data-sel-price]');
    const nameOut = $$('[data-sel-name]');
    const radios = $$('input[name="id"]', form);
    // the gallery belonging to this form's section, not just the first on the page
    const scope = form.closest('.shopify-section') || document;
    const gallery = $('[data-gallery]', scope) || $('[data-gallery]');
    const mainImg = gallery && $('[data-gallery-main]', gallery);

    function sync() {
      const r = $('input[name="id"]:checked', form); if (!r) return;
      priceOut.forEach(o => o.textContent = money(+r.dataset.price));
      nameOut.forEach(o => o.textContent = r.dataset.name);

      // move the highlight onto the option that is actually checked
      radios.forEach(x => {
        const label = x.closest('.opt');
        if (label) label.classList.toggle('sel', x === r);
      });

      // swap the main photo to this variant's own image. Set the src directly
      // rather than looking for a matching thumbnail — the gallery may be
      // showing the theme's pouch photos, which have no variant media to match.
      if (mainImg && mainImg.dataset.swap !== 'off') {
        const src = r.dataset.imageSrc || mainImg.dataset.defaultSrc;
        if (src && mainImg.getAttribute('src') !== src) {
          mainImg.removeAttribute('srcset');
          mainImg.src = src;
        }
        if (gallery) {
          const match = r.dataset.image && $(`[data-gallery-thumb][data-media="${r.dataset.image}"]`, gallery);
          $$('[data-gallery-thumb]', gallery).forEach(t => t.setAttribute('aria-pressed', t === match ? 'true' : 'false'));
        }
      }

      if (btn) btn.disabled = r.dataset.available === 'false';
    }
    radios.forEach(r => r.addEventListener('change', sync));
    sync();
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const r = $('input[name="id"]:checked', form); if (!r) return;
      await addToCart(r.value, 1);
    });
    $$('[data-add-remote]').forEach(b => b.addEventListener('click', () => form.requestSubmit()));
  });

  /* cart */
  const drawer = $('#CartDrawer'), overlay = $('#CartOverlay'), body = $('#CartBody');
  function open() { if (!drawer) return; drawer.classList.add('on'); overlay.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); }
  function close() { if (!drawer) return; drawer.classList.remove('on'); overlay.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); }
  $$('[data-open-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); refresh().then(open); }));
  $$('[data-close-cart]').forEach(b => b.addEventListener('click', close));
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  async function addToCart(id, quantity) {
    const btns = $$('[data-add],[data-add-remote]');
    btns.forEach(b => b.disabled = true);
    try {
      const res = await fetch(D.routes.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity }] }) });
      if (!res.ok) { const j = await res.json().catch(() => ({})); toast((j.description || 'COULD NOT ADD').toUpperCase()); return; }
      await refresh(); open(); toast('ADDED TO CART');
    } finally { btns.forEach(b => b.disabled = false); }
  }
  async function change(line, quantity) {
    await fetch(D.routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    await refresh();
  }
  async function refresh() {
    let cart;
    try {
      const res = await fetch(D.routes.cartJson);
      if (!res.ok) return null;
      cart = await res.json();
    } catch (e) { return null; }
    $$('[data-cart-count]').forEach(e => e.textContent = cart.item_count);
    if (body) render(cart);
    return cart;
  }
  function render(cart) {
    const cfg = drawer.dataset;
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty"><div class="big">:(</div><h3 class="disp">${cfg.emptyTitle}</h3><p>${cfg.emptyText}</p><button class="cta" data-close-cart style="margin-top:16px">${cfg.emptyCta}</button></div>`;
      $('[data-close-cart]', body).onclick = close; return;
    }
    let h = '';
    cart.items.forEach((it, i) => {
      h += `<div class="line"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_128x128$1$2') : ''}" alt=""><div><div class="t">${it.product_title}</div><div class="d">${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : ''}</div><div class="qty"><button data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="Increase">+</button></div></div><div class="p">${money(it.final_line_price)}</div></div>`;
    });
    const at = +D.freeShipAt || 0, sub = cart.items_subtotal_price, left = Math.max(0, at - sub);
    if (at > 0) h += `<div class="free">${left > 0 ? `${cfg.freeText.replace('[amount]', `<b>${money(left)}</b>`)}` : `<span class="ok">✓ ${cfg.freeDone}</span>`}<div class="track"><div class="fill" style="width:${Math.min(100, sub / at * 100)}%"></div></div></div>`;
    const bumpId = cfg.bumpId;
    if (bumpId && !cart.items.some(it => String(it.variant_id) === bumpId)) {
      h += `<label class="bump"><input type="checkbox" data-bump="${bumpId}"><div><b>${cfg.bumpTitle}</b><span>${cfg.bumpText}</span><div class="bp">${cfg.bumpCompare ? `<s>${cfg.bumpCompare}</s> ` : ''}${cfg.bumpPrice}</div></div></label>`;
    }
    h += `<div class="tot">${cart.total_discount ? `<div class="disc"><span>Discounts</span><span>−${money(cart.total_discount)}</span></div>` : ''}<div><span>Subtotal</span><span>${money(cart.items_subtotal_price)}</span></div><div class="g"><span>TOTAL</span><span>${money(cart.total_price)}</span></div></div>
      <p style="font-size:12px;color:var(--dim);margin:0 0 12px">${cfg.shipNote}</p>
      <a class="cta" href="/checkout">${cfg.checkoutLabel} · ${money(cart.total_price)}</a>
      <div class="lock">🔒 ${cfg.lockText}</div>`;
    body.innerHTML = h;
    $$('[data-line]', body).forEach(b => b.onclick = () => change(+b.dataset.line, +b.dataset.q));
    const bb = $('[data-bump]', body); if (bb) bb.onchange = () => addToCart(bb.dataset.bump, 1);
  }
  refresh();
  window.Disco.addToCart = addToCart;
})();
